/* 
Este arquivo � gerado automaticamente atrav�s do build executado pelo Jenkins. 
A variavel VERSAO_SISTEMA contempla a vers�o no padr�o VEC que foi constru�da no build. 
*/ 
var VERSAO_SISTEMA = '06.00.03.003'; 
var BUILD_NUMBER = '287'; 
var JOB_NAME = 'SICNS-REGISTRO'; 
var BUILD_TIMESTAMP = '2026-04-17 09:13:51 BRT'; 
